import { render, staticRenderFns } from "./BringupsMonth.vue?vue&type=template&id=6481a04e"
import script from "./BringupsMonth.vue?vue&type=script&lang=js"
export * from "./BringupsMonth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports